export enum SeparationType {
    Prescription = 1,
    NonPrescription = 2,
    HomeTryOn = 3,
    Default = 4
}